export function collectPaymentNeedsReference(method, amountCentavos) {
  return String(method || "").toLowerCase() !== "cash" && Number(amountCentavos || 0) > 0;
}

export function buildCollectPaymentRpcArgs({
  planId,
  amountCentavos,
  method,
  notes,
  referenceNumber,
  proofUrl,
  idempotencyKey,
} = {}) {
  return {
    p_plan_id: planId,
    p_amount_centavos: Number(amountCentavos || 0),
    p_method: method,
    p_notes: cleanOptional(notes),
    p_reference_number: cleanOptional(referenceNumber),
    p_proof_url: cleanOptional(proofUrl),
    p_idempotency_key: cleanOptional(idempotencyKey),
  };
}

function cleanOptional(value) {
  const clean = String(value || "").trim();
  return clean || null;
}
